import { Controller, useFormContext } from "react-hook-form";

import { Gql } from "@smart/manage-gql-operations-dom";

import { LogoUpload } from "./logo-upload";

type BrandingInput = NonNullable<
  Gql.UpdateSettingMutationVariables["fields"]["branding"]
>;

type BrandLogoProps = {
  uploading: boolean;
  setUploading: (uploading: boolean) => void;
};

export const BrandLogo = ({ uploading, setUploading }: BrandLogoProps) => {
  const { control } = useFormContext<BrandingInput>();

  return (
    <div className="flex flex-col gap-small">
      <div className="text-paragraph font-semibold">Logo</div>
      <Controller
        control={control}
        name="logo"
        render={({ field }) => (
          <LogoUpload
            url={field.value}
            onUpdate={field.onChange}
            uploading={uploading}
            setUploading={setUploading}
          />
        )}
      />
    </div>
  );
};
